import React, { useEffect, useState } from "react";
import CTable from "components/common/Table";
import { withRouter } from "react-router";
import PieChartWithCenterLabel from "components/common/PieChartWithCenterLabel";
import Box from "components/common/Box";
import Text from "components/common/Text";
import { Chip } from "@mui/material";
import { makeStyles } from "@mui/styles";

const CustomerChargingHistoryTabs = ({ data, loading }) => {
  const classes = useStyles();

  const [activeManufacturer, setActiveManufacturer] = useState();
  const [powerManu, setPowerManu] = useState();

  const columns = [
    { field: "charging_station", headerName: "Charging Station" },
    { field: "network", headerName: "Network" },
    { field: "date", headerName: "Date" },
    { field: "time", headerName: "Time" },
    { field: "charging_time", headerName: "Charging Time" },
    { field: "amount", headerName: "Amount" },
  ];
  const filteredData = data?.visitDetails?.filter((el) => {
    if (activeManufacturer === "") {
      return el;
    } else {
      return el?.manufacturer?.includes(activeManufacturer);
    }
  });

  const option_1 = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: "pie",
      width: 280,
      height: 150,

      style: {
        float: "left",
      },
    },
    title: {
      text: "",
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
    },
    legend: {
      align: "right",
      verticalAlign: "middle",
      x: 0,
      y: -10,
      itemMarginTop: 10,
      useHTML: true,
    },
    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: false,
        },
        showInLegend: true,
      },
    },
    credits: false,
    series: [
      {
        innerSize: "70%",
        name: "Brands",
        colorByPoint: true,
        data: [
          {
            name: `${activeManufacturer} ${powerManu?.totalTime}min`,
            color: activeManufacturer === "Tata" ? "#21D59B" : "#F99600",
            y: powerManu?.totalTime,
            width: 15,
            height: 15,
            borderRadius: 3,
          },
        ],
      },
    ],
  };

  const option_power = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: "pie",
      width: 280,
      height: 150,

      style: {
        float: "left",
      },
    },
    title: {
      text: "",
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
    },
    legend: {
      align: "right",
      verticalAlign: "middle",
      x: 0,
      y: -10,
      itemMarginTop: 10,
      useHTML: true,
    },
    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: false,
        },
        showInLegend: true,
      },
    },
    credits: false,
    series: [
      {
        innerSize: "70%",
        name: "Brands",
        colorByPoint: true,
        data: [
          {
            name: `${activeManufacturer} ${powerManu?.totalPowerConsumed} kw`,
            color: activeManufacturer === "Tata" ? "#21D59B" : "#F99600",
            y: powerManu?.totalPowerConsumed,
            width: 15,
            height: 15,
            borderRadius: 3,
          },
        ],
      },
    ],
  };

  const ManufacturerComponent = ({
    manufacturer,
    isActive,
    onClick,
    manufacturerdata,
  }) => (
    <Chip
      style={{
        background: isActive ? "#0DA861" : "#FFFFFF",
        color: isActive ? "#FFFFFF" : "#ACACAC",
        border: isActive ? "none" : "1px solid #ACACAC",
        marginRight: "10px",
      }}
      label={manufacturer}
      variant="outlined"
      onClick={onClick}
    />
  );

  const handleClick = (manufacturer, manufacturerdata) => {
    setActiveManufacturer(manufacturer);
    setPowerManu(manufacturerdata);
  };

  

  useEffect(() => {
    if (data?.unitsByManufacturer) {
      Object.entries(data?.unitsByManufacturer).forEach(([key, value], index) => {
          setActiveManufacturer(key);
      setPowerManu({
        totalPowerConsumed: value?.totalPowerConsumed,
        totalTime: value?.totalTime,
      });
      });
    }
  }, [data]);
  
  
  

  return (
    
    <>
      <Box className={classes.checkInChargingHistoryContainer}>
        <Box className={classes.checkInChargingHistorybox}>
          <Text className={classes.checkInChargingHistoryTimeText}>
            Total Time Consumption
          </Text>
          <Box style={{ position: "relative" }}>
            <PieChartWithCenterLabel options={option_1} />
            <div className={classes.chartTimeContainer}>
              <p className={classes.chartTimeText}>
                {powerManu?.totalTime} min
              </p>
              <img
                className={classes.chartTimeImage}
                src="/images/chargingSwtich.svg"
                alt="logo"
              />
            </div>
          </Box>
        </Box>
        <Box className={classes.totalPowerConatiner}>
          <Text className={classes.totalPowerText}>
            Total Power Consumption
          </Text>
          <Box style={{ position: "relative" }}>
            <PieChartWithCenterLabel options={option_power} />
            <div className={classes.chartPowerConatiner}>
              <p className={classes.chartPowerText}>
                {powerManu?.totalPowerConsumed} kw
              </p>
              <img
                className={classes.totalPowerImage}
                src="/images/chargingSwtich.svg"
                alt="logo"
              />
            </div>
          </Box>
        </Box>
      </Box>
      <Box style={{ marginBottom: "10px" }}>
        {Object.entries(data?.unitsByManufacturer).map(
          ([manufacturer, manufacturerdata]) => (
            <ManufacturerComponent
              key={manufacturer}
              manufacturer={manufacturer}
              isActive={manufacturer === activeManufacturer}
              onClick={() => handleClick(manufacturer, manufacturerdata)}
              manufacturerdata={manufacturerdata}
            />
          )
        )}
      </Box>
      <CTable
        columns={columns}
        data={filteredData}
        isLoading={loading?.isLoading}
        pagination
        localPagination
        page={0}
        rowsPerPage={5}
      />
    </>
  );
};

export default withRouter(CustomerChargingHistoryTabs);

const useStyles = makeStyles((theme) => ({
  checkInChargingHistoryContainer: {
    display: "flex",
    gap: "10px",
    margin: "10px 0px",
  },
  checkInChargingHistorybox: {
    border: "1px solid #DEDEDE",
    borderRadius: "20px",
    padding: "20px",
  },
  checkInChargingHistoryTimeText: {
    color: "#666666",
    fontSize: "16px",
    borderBottom: "1px solid #DEDEDE",
    marginBottom: "5px",
  },
  chartTimeContainer: {
    display: "inline-block",
    position: "absolute",
    top: "47px",
    marginLeft: "46px",
    width: "30px",
    textAlign: "center",
  },
  chartTimeText: {
    fontSize: "10px",
    fontWeight: "700",
    textAlign: "center",
    width: "45px",
  },
  chartTimeImage: {
    width: "12px",
    position: "absolute",
    top: "30px",
  },
  totalPowerConatiner: {
    border: "1px solid #DEDEDE",
    borderRadius: "20px",
    padding: "20px",
  },
  totalPowerText: {
    color: "#666666",
    fontSize: "16px",
    borderBottom: "1px solid #DEDEDE",
    marginBottom: "5px",
  },
  chartPowerConatiner: {
    display: "inline-block",
    position: "absolute",
    top: "42px",
    marginLeft: "49px",
    width: "30px",
    textAlign: "center",
  },
  chartPowerText: {
    fontSize: "10px",
    fontWeight: "700",
    textAlign: "center",
    width: "50px",
  },
  totalPowerImage: {
    width: "12px",
    position: "absolute",
    top: "30px",
  },
}));
